import React from "react";

/**
 * Skeleton loader primitives. replaces "Loading…" italic text across the app.
 *
 * Use:
 * <Skeleton className="h-4 w-32" />
 * <SkeletonCard /> (card with title + 3 lines + button)
 * <SkeletonListItem /> (single list row)
 * <SkeletonPhotoGrid count={6} />
 */
export function Skeleton({ className = "",...rest }) {
 return <div className={`skeleton ${className}`} {...rest} />;
}

export function SkeletonCard() {
 return (
 <div className="card">
 <Skeleton className="h-5 w-2/3 mb-3" />
 <Skeleton className="h-3 w-full mb-2" />
 <Skeleton className="h-3 w-5/6 mb-2" />
 <Skeleton className="h-3 w-3/4 mb-5" />
 <Skeleton className="h-9 w-32" />
 </div>
 );
}

export function SkeletonListItem() {
 return (
 <div className="border border-[#E5E4DE] bg-white p-4 flex items-center gap-3">
 <Skeleton className="h-10 w-10 shrink-0 rounded" />
 <div className="flex-1 min-w-0">
 <Skeleton className="h-4 w-1/2 mb-2" />
 <Skeleton className="h-3 w-1/3" />
 </div>
 </div>
 );
}

export function SkeletonPhotoGrid({ count = 6 }) {
 return (
 <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
 {Array.from({ length: count }).map((_, i) => (
 <Skeleton key={i} className="aspect-[4/3] w-full" />
 ))}
 </div>
 );
}

export function SkeletonText({ lines = 3 }) {
 return (
 <div className="space-y-2">
 {Array.from({ length: lines }).map((_, i) => (
 <Skeleton
 key={i}
 className={`h-3 ${i === lines - 1 ? "w-2/3" : "w-full"}`}
 />
 ))}
 </div>
 );
}
